var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeeFul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7542 11.9997C14.9962 11.9997 16.003 13.0065 16.003 14.2486V15.167C16.003 15.7404 15.8238 16.2994 15.4905 16.7659C13.9446 18.9292 11.4203 20.0008 8 20.0008C4.57903 20.0008 2.05607 18.9287 0.513908 16.7643C0.181945 16.2984 0.00354004 15.7406 0.00354004 15.1685V14.2486C0.00354004 13.0065 1.0104 11.9997 2.25242 11.9997H13.7542ZM8 0.00439453C10.7614 0.00439453 13 2.24297 13 5.00439C13 7.76582 10.7614 10.0044 8 10.0044C5.23857 10.0044 3 7.76582 3 5.00439C3 2.24297 5.23857 0.00439453 8 0.00439453Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeFul);
export default __webpack_public_path__ + "static/media/employee-ful.33e24ca90683934b0ad6e83546f938ac.svg";
export { ForwardRef as ReactComponent };